module.exports = __webpack_public_path__ + "static/media/13.2c94f21c.jpg";